module.exports = __webpack_public_path__ + "static/media/img_header_submit_inquiry.7cfe2dda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/submitInquiry/assets/img_header_submit_inquiry.jpg
// module id = 1079
// module chunks = 1